/* eslint-disable no-undef */
import SwalConfig from "@/swalConfig";
import { green } from "../../constants/colors";

const successAlert = (type, longOfCampaign) => {
  const message =
    localStorage.getItem("language") === "en" || localStorage.getItem("language") === null
      ? type === "created"
        ? "Campaign created successfully!"
        : type === "createMulti"
          ? `Your campaign is created successfully!`
          : type === "updated"
            ? "Campaign updated successfully"
            : "Campaign deleted successfully"
      : type === "created"
        ? "تم انشاء الحملة بنجاح!"
        : type === "createMulti"
          ? `تم انشاء الحملة بنجاح! سيتم تقسيم الحملة الى ${longOfCampaign} حملة متعلقة بمستوى حسابك`
          : type === "updated"
            ? "تم تعديل الحملة بنجاح"
            : "تم حذف الحملة بنجاح";
  SwalConfig({
    position: "center",
    icon: "success",
    title: `<span style="color: #757575; font-size:1.2rem">${message}</span>`,
    confirmButtonText: "Thank you",
    confirmButtonColor: green,
    showConfirmButton: longOfCampaign ? true : false,
    timer: longOfCampaign ? 0 : 1500,
  });
};

const failAlert = (type) => {
  const message =
    localStorage.getItem("language") === "en" || localStorage.getItem("language") === null
      ? type === "created"
        ? "The campaign not created!"
        : type === "updated"
          ? "The campaign not edited"
          : "The campaign not deleted!"
      : type === "created"
        ? "لم يتم انشاء الحملة!"
        : type === "updated"
          ? "لم يتم تعديل الحملة!"
          : "لم يتم حذف الحملة";
  const html =
    localStorage.getItem("language") === "en" || localStorage.getItem("language") === null
      ? "<p>Some errors were found <br> Please contact support team!</p>"
      : "<p>تم العثور على بعض المشاكل <br> تواصل مع فريق الدعم من فضلك!</p>";

  SwalConfig({
    position: "center",
    icon: "error",
    title: `<strong style="color: ${green}; font-size:1.2rem"> ${message}</strong>`,
    html,
    confirmButtonColor: green,
    showConfirmButton: true,
  });
};
export { successAlert, failAlert };
